module.exports = __webpack_public_path__ + "static/media/pic1.53726df8.jpg";